// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import WelcomeController from "./welcome_controller"
application.register("welcome", WelcomeController)

import PickComposeController from "./pick_compose_controller"
application.register("pick-compose", PickComposeController)

import PickRefreshController from "./pick_refresh_controller"
application.register("pick-refresh", PickRefreshController)
